import React from 'react'
import {
  $DCDangerColor,
  $DCDangerLightColor,
  $DCInfoColor,
  $DCInfoLightColor,
  $DCSuccessColor,
  $DCSuccessLightColor,
  $DCWarningColor,
  $DCWarningLightColor,
  DcSwitch,
  DcTag,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelHeaderPanel,
  PixelLeftPanel,
  PixelPageContainer,
  PixelRightPanel,
  PixelSpinner,
  PixelText,
  PixelTooltip,
  Section,
  SectionContent,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs/ajax'

import { get, put } from 'utils/api-routes.util'
import { SectionTitle } from 'app/common/styles/section'

import StoreLogos from './components/StoreLogos'
import { IPixelFactory } from '../../../../../../decl.d'

interface IStoreDetail {
  store_name: string
  store_status: string
  print_invoice_address_by_warehouse: boolean
  print_label_address_by_warehouse: boolean
}

interface IResponse {
  data?: IPickupLocations
  error?: string
  success?: boolean
}

const StoreDetail = (props: {
  storeId: string
  setShowDetailModal: (show: boolean) => void
}) => {
  const { storeId } = props
  const storeInfoRef = React.useRef(null)
  const warehouseSettingsRef = React.useRef(null)
  const [isShowSpinner, setIsShowSpinner] = React.useState(false)

  const { showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [store, setStore] = React.useState<IStoreDetail>({})

  const storeData = () => {
    // showLoader(storeInfoRef)
    setIsShowSpinner(true)
    get(`/tenant/stores/${storeId}`).subscribe(
      (res: AjaxResponse<IResponse | any>) => {
        setStore(res?.response?.data)
        setIsShowSpinner(false)
      },
    )
  }

  const updateWarehouseInvoicePrint = (_data: {
    print_invoice_address_by_warehouse: boolean
  }) => {
    // showLoader(warehouseSettingsRef)
    setIsShowSpinner(true)
    put(`/tenant/stores/${storeId}/invoice`, _data).subscribe(
      (res: AjaxResponse<IResponse | any>) => {
        // hideLoader(warehouseSettingsRef)
        setIsShowSpinner(false)
        if (res.response?.data === null || res.response?.data === true) {
          setStore({
            ...store,
            print_invoice_address_by_warehouse:
              res.response?.data == null ? false : res.response?.data,
          })
          showSuccess(
            res.response?.data
              ? 'Invoice settings updated'
              : 'Invoice settings updated',
          )
        } else {
          showFailure(res?.response?.error ?? 'Something went wrong')
        }
      },
    )
  }

  const updateWarehouseLabelPrint = (_data: {
    print_label_address_by_warehouse: boolean
  }) => {
    // showLoader(warehouseSettingsRef)
    setIsShowSpinner(true)
    put(`/tenant/stores/${storeId}/label`, _data).subscribe(
      (res: AjaxResponse<IResponse | any>) => {
        // hideLoader(warehouseSettingsRef)
        setIsShowSpinner(false)
        if (res.response?.data === null || res.response?.data === true) {
          setStore({
            ...store,
            print_label_address_by_warehouse:
              res.response?.data == null ? false : res.response?.data,
          })
          showSuccess(
            res.response?.data
              ? 'shipping label settings updated'
              : 'shipping label settings updated',
          )
        } else {
          showFailure(res?.response?.error ?? 'Something went wrong')
        }
      },
    )
  }
  React.useEffect(() => {
    if (storeId == null) return
    storeData()
  }, [storeId])
  const tableDetailStyle = {
    width: '100%',
    display: 'table',
    tableLayout: 'fixed',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  }

  const identifierStyle = {
    fontSize: '16px',
    fontWeight: '600',
    color: '#8e959b',
    display: 'table-cell',
    verticalAlign: 'middle',
    // padding: '10px',
    width: '40%',
    // backgroundColor: '#e9ecef',
  }

  const detailStyle = {
    // backgroundColor: '#e9ecef78',
    fontSize: '16px',
    fontWeight: '400',
    color: '#8e959b',
    display: 'table-cell',
    verticalAlign: 'middle',
    paddingLeft: '10px',
  }

  return (
    <>
      <PixelSpinner isShow={isShowSpinner} />
      <PixelPageContainer>
        <Section ref={storeInfoRef} style={{ padding: '0px' }}>
          <SectionContent>
            <PixelHeaderPanel>
              <PixelLeftPanel>
                <Section>
                  <SectionTitle>Info</SectionTitle>
                  {/* <SectionContent className="p-0 user-info"> */}
                  <PixelDiv style={tableDetailStyle}>
                    <PixelDiv style={identifierStyle}>
                      {store?.store_name}
                    </PixelDiv>
                    <PixelDiv style={detailStyle}>
                      {store && <StoreLogos store_type={store?.store_type} />}
                    </PixelDiv>
                  </PixelDiv>

                  <PixelDiv style={tableDetailStyle}>
                    <PixelDiv style={identifierStyle}>Status:</PixelDiv>
                    <PixelDiv style={detailStyle}>
                      {/* <PixelTag>{store?.store_status}</PixelTag> */}
                      {store?.store_status === 'ready' ? (
                        <DcTag
                          textColor={$DCSuccessColor}
                          customBackgroundColor={$DCSuccessLightColor}
                          className="success"
                        >
                          Ready
                        </DcTag>
                      ) : store?.store_status === 'sync' ? (
                        <DcTag
                          textColor={$DCInfoColor}
                          customBackgroundColor={$DCInfoLightColor}
                        >
                          Sync
                        </DcTag>
                      ) : store?.store_status === 'pending' ? (
                        <DcTag
                          textColor={$DCWarningColor}
                          customBackgroundColor={$DCWarningLightColor}
                        >
                          Pending
                        </DcTag>
                      ) : store?.store_status === 'failed' ? (
                        <>
                          <DcTag
                            textColor={$DCDangerColor}
                            customBackgroundColor={$DCDangerLightColor}
                          >
                            Failed
                          </DcTag>
                        </>
                      ) : (
                        '--'
                      )}
                    </PixelDiv>
                  </PixelDiv>
                  {/* </SectionContent> */}
                </Section>
              </PixelLeftPanel>
              <PixelRightPanel ref={warehouseSettingsRef}>
                <Section
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#171717',
                    paddingLeft: '30px',
                  }}
                >
                  <SectionTitle>Settings</SectionTitle>
                  <PixelFlexBox flexDirection="column">
                    <PixelFlexBox
                      margin="0 0 4px 0"
                      flexDirection="row"
                      justifyContent="space-between"
                      alignItems="center"
                      alignContent="center"
                      gap="10px"
                    >
                      <PixelDiv style={{ width: '12%' }}>
                        <DcSwitch
                          value={store?.print_invoice_address_by_warehouse}
                          checked={store?.print_invoice_address_by_warehouse}
                          label={
                            store?.print_invoice_address_by_warehouse
                              ? 'Yes'
                              : 'No'
                          }
                          onChange={(e) => {
                            updateWarehouseInvoicePrint({
                              print_invoice_address_by_warehouse:
                                e.target.checked,
                            })
                          }}
                        />
                      </PixelDiv>
                      <PixelFlexBox flexDirection="column">
                        <PixelDiv>
                          <PixelText
                            tooltip="How to get the API Key?"
                            style={{
                              fontFamily: 'Courier New',
                              width: '80%',
                              padding: '5px',
                              wordWrap: 'break-word',
                            }}
                          >
                            <PixelTooltip
                              tooltipText={
                                'Include the warehouse address in the "From" section of the invoice for printing purposes.'
                              }
                            >
                              Print Warehouse Address on Invoice
                            </PixelTooltip>
                          </PixelText>
                        </PixelDiv>
                      </PixelFlexBox>
                    </PixelFlexBox>
                    <PixelFlexBox
                      flexDirection="row"
                      justifyContent="space-between"
                      alignItems="center"
                      alignContent="center"
                      gap="10px"
                    >
                      <PixelDiv style={{ width: '12%' }}>
                        <DcSwitch
                          value={store?.print_label_address_by_warehouse}
                          checked={store?.print_label_address_by_warehouse}
                          label={
                            store?.print_label_address_by_warehouse
                              ? 'Yes'
                              : 'No'
                          }
                          onChange={(e) => {
                            updateWarehouseLabelPrint({
                              print_label_address_by_warehouse:
                                e.target.checked,
                            })
                          }}
                        />
                      </PixelDiv>
                      <PixelFlexBox flexDirection="column">
                        <PixelText
                          style={{
                            fontFamily: 'Courier New',
                            width: '80%',
                            padding: '5px',
                            wordWrap: 'break-word',
                          }}
                        >
                          <PixelTooltip
                            tooltipText={
                              'Include the warehouse address in the "Shipper" section of the Shipping label for printing purposes.'
                            }
                          >
                            Print Warehouse Address on Shipping Label
                          </PixelTooltip>
                        </PixelText>
                      </PixelFlexBox>
                    </PixelFlexBox>
                  </PixelFlexBox>
                </Section>
              </PixelRightPanel>
            </PixelHeaderPanel>
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}
export default StoreDetail
